import { render, staticRenderFns } from "./BoxConfigurator.vue?vue&type=template&id=6ef70014&scoped=true&"
import script from "./BoxConfigurator.vue?vue&type=script&lang=js&"
export * from "./BoxConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./BoxConfigurator.vue?vue&type=style&index=0&id=6ef70014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef70014",
  null
  
)

export default component.exports